import { render, staticRenderFns } from "./side-bar-department.vue?vue&type=template&id=3d65076f&"
import script from "./side-bar-department.vue?vue&type=script&lang=js&"
export * from "./side-bar-department.vue?vue&type=script&lang=js&"
import style0 from "./side-bar-department.vue?vue&type=style&index=0&id=3d65076f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports